import { render, staticRenderFns } from "./examLinkList.vue?vue&type=template&id=475b030c&scoped=true&"
import script from "./examLinkList.vue?vue&type=script&lang=js&"
export * from "./examLinkList.vue?vue&type=script&lang=js&"
import style0 from "./examLinkList.vue?vue&type=style&index=0&id=475b030c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b030c",
  null
  
)

export default component.exports